import * as React from "react";
import { Grid } from "@mui/material";
import Breadcrumbs from "../../containers/Breadcrumbs";
import ReturnToLandingPageButton from "../../containers/ReturnToLandingPageButton";
import BackButton from "../../containers/BackButton";
import FinancialReportDetailsSearchForm from "../../containers/FinancialReportDetailsSearchForm";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";

export default function DefineCustomReport() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs currentPageBreadCrumbTitle="Define Custom Peer Groups" />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <ReturnToLandingPageButton />
      <BackButton
        app="FinancialReporting"
        buttonLabel="Back to Financial Reporting"
        variant="dark"
      />
      <FinancialReportDetailsSearchForm
        data={[{}]}
        fromLevelOne={false}
        customVariant
        returnPath={`${AppUrl("PeerGroup")}/manage?reloadReports=true`}
      />
    </>
  );
}
